<input type="text" [attr.id]="inputId" inputmode="decimal" class="form-control" [value]="displayValue" [readonly]="readonly" [placeholder]="placeholder" [disabled]="isDisabled" (input)="onInput($any($event.target))" (blur)="onBlur()">
